import React from 'react';
import RecipeBuilderGridControls from './RecipeBuilderGridControls';
import { InputBase, inputBaseClasses, styled } from '@mui/material';

const StyledInput = styled(InputBase)((theme) => ({
  background: '#FFF',
  border: '1px solid #DFE8F0',
  borderRadius: 8,
  fontSize: 14,
  [`.${inputBaseClasses.input}`]: {
    minWidth: 200,
    height: 'auto',
    padding: 8,
    fontFamily: 'Rubik',
    fontSize: 12,
    fontWeight: 400,
    color: '#2F3037',
  },
}));

class RecipeBuilderHeader extends React.PureComponent {
  render() {
    const {
      dataSet,
      dataSetName,
      isSplitMode,
      numSamples,
      liveSamples,
      selectedViewMode,
      showMeta,
      onNumSamplesChanged,
      onDownloadSamples,
      onRefreshSamples,
      isLoadingSamples,
      onViewModeChanged,
      onShowMetaChanged,
    } = this.props;

    return (
      <div className="recipe-builder-header">
        {!isSplitMode && (
          <StyledInput
            className="nexset-name"
            variant="filled"
            placeholder="Nexset Name"
            value={dataSetName}
            onChange={this._handleDataSetNameChanged}
          />
        )}
        <RecipeBuilderGridControls
          dataSet={dataSet}
          numSamples={numSamples}
          liveSamples={liveSamples}
          loadingSamples={isLoadingSamples}
          selectedViewMode={selectedViewMode}
          showMeta={showMeta}
          onNumSamplesChanged={onNumSamplesChanged}
          onDownloadSamples={onDownloadSamples}
          onRefreshSamples={onRefreshSamples}
          onViewModeChanged={onViewModeChanged}
          onShowMetaChanged={onShowMetaChanged}
        />
      </div>
    );
  }

  _handleDataSetNameChanged = (e) => {
    this.props.onDataSetNameChanged(e.target.value);
  };
}

export default RecipeBuilderHeader;
